import React, { Component } from "react";
import { connect } from "react-redux";
import Info from "../shared/Info";
import {
  askToAgents,
  selectWorkflow,
} from "../../../state/ducks/workflow/index";
import $ from "jquery";


function temsilcimeSoruSor() {

  var konu = $("#subject").val();
  var mesaj = $("#description").val();
  var durum = 1;

  // anlık kontrol için 
  document.querySelector('#onaychecked').addEventListener("change", function () {
      if ($("#onaychecked").is(':checked')) {
          $(".t-tooltip").css({ "display": "none" });
      } else {
          $(".t-tooltip").css({ "display": "flex" });
      }
  });

  document.querySelector('#subject').addEventListener("change", function () {
      konu = $("#subject").val();
      if (konu == "") {
        durum = 0;
          $("#subject").parent().addClass("t-error");
          $("#subject").next().html("<i class='t-icon-error text-danger'></i>");
          $("#subject_hatamesaj").html("Konu alanı boş bırakılamaz");
      } else {
          $("#subject").parent().removeClass("t-error");
          $("#subject").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
          $("#subject_hatamesaj").html("");
      }
  });

  document.querySelector('#description').addEventListener("change", function () {
      mesaj = $("#description").val();
      if (mesaj == "") {
          durum = 0; 
          $("#description").parent().addClass("t-error");
          $("#description").next().html("<i class='t-icon-error text-danger'></i>");
          $("#description_hatamesaj").html("Konu alanı boş bırakılamaz");
      } else {
          durum = 1;
          $("#description").parent().removeClass("t-error");
          $("#description").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
          $("#description_hatamesaj").html("");
      }
  });

  // checkbox kontrol
  if ($("#onaychecked").is(':checked')) {
      $(".t-tooltip").css({ "display": "none" });
  } else {
      durum = 0; // Seçili değil
      $(".t-tooltip").css({ "display": "flex" });
  }

  // konu boş mu kontrol
  if (konu == "") {
      durum = 0; // Konu Boş
      $("#subject").parent().addClass("t-error");
      $("#subject").next().html("<i class='t-icon-error text-danger'></i>");
      $("#subject_hatamesaj").html("Konu alanı boş bırakılamaz");
  } else {
      $("#subject").parent().removeClass("t-error");
      $("#subject").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
      $("#subject_hatamesaj").html("");
  }
  // Açıklama boş mu kontrol
  if (mesaj == "") {
      durum = 0; // Mesaj Boş
      $("#description").parent().addClass("t-error");
      $("#description").next().html("<i class='t-icon-error text-danger'></i>");
      $("#description_hatamesaj").html("Mesaj alanı boş bırakılamaz");
  }else {
      $("#description").parent().removeClass("t-error");
      $("#description").next().html("<i class='t-icon-check_circle_outline text-success'></i>");
      $("#description_hatamesaj").html("");
  };
  return durum;
}

export class AskToAgent extends Component {
  state = {
    uyeNo: "0",
    konu: "",
    aciklama: "",
  };

  onSubmit = (e) => {
    e.preventDefault();

   if(temsilcimeSoruSor()==1){

     this.props.askToAgents(this.state.konu, this.state.aciklama);

   }

  };

  render() {
    const { workflow } = this.props;
    if (workflow?.addedAgent) {
      return (
        <Info
          header={"Talebiniz alınmıştır."}
          body={
            "Talebiniz ile ilgili gelişmeleri 'Talep Takibi' menüsünden takip edebilirsiniz."
          }
        ></Info>
      );
    } else {
      return (
        <div className="container-fluid">
          {/* Yeşil Alan*/}
          <div className="row" style={{ padding: "3%" }}>
            <div className="col-12">
              {/* KUTU 1 */}
              <div className="row no-gutters t-kutu t-mavicizgi">
                <div
                  className="col bosluk backright"
                  style={{
                    backgroundImage:
                      'url("/assets/img/backgrounds/back_right_mavi.jpg")'
                  }}
                >
                  {/* içerikler */}
                  {/* Başlık */}
                  <div className="row no-gutters pb-4">
                    <div clss="col-auto">
                      <i className="t-icon-user-tie  icon" />
                    </div>
                    <div className="col d-flex flex-column justify-content-center">
                      <div className="baslik" style={{ padding: "0 0 5px 0" }}>
                        Temsilcim
                      </div>
                      <span className="altBaslik">Temsilcime Soru Sor</span>
                    </div>
                  </div>
                  <div className="row no-gutters">
                  
                    {/* Konu */}
                    <div className="col-12 pb-1">
                      <span className="t-icInputTitle pl-3">Konu</span>
                    </div>
                    <div className="col-12">
                      <div className="t-icInput">
                        <div>
                          <i className="t-icon-pen1" />
                        </div>
                        <input
                          type="text"
                          placeholder="Konu Başlığınızı Yazınız"
                          id="subject"
                      name="subject"                  
                     
                      value={this.state.konu}
                      required
                      maxLength="200"
                      onChange={(e) => {
                        this.setState({ konu: e.target.value });
                      }}
                        />
                        <div />
                      </div>
                    </div>
                    {/* KONU Hata mesajının geleceği alan*/}
                    <div
                      className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                      id="subject_hatamesaj"
                    />
                    {/* Açıklama*/}
                    <div className="col-12 pb-1">
                      <span className="t-icInputTitle pl-3">Açıklama</span>
                    </div>
                    <div className="col-12">
                      <div className="t-icInput">
                        <div>
                          <i className="t-icon-bubble1" />
                        </div>
                        <textarea
                          
                          placeholder="Mesajınızı Yazınız"
                          id="description"
                        name="description"
                        
                        rows="3"
                        maxLength="1000"                     
                        required
                        value={this.state.aciklama}
                        onChange={(e) => {
                          this.setState({ aciklama: e.target.value });
                        }}
                          
                        />
                        <div />
                      </div>
                    </div>
                    {/* Mesaj Hata mesajının geleceği alan*/}
                    <div
                      className="col-12 t-icinputHatamesajArea pl-3 pt-1"
                      id="description_hatamesaj"
                    />
                    {/* checkbox */}
                    <div className="col-12 d-flex align-items-center pb-3">
                      <input
                        type="checkbox"
                        className="t-temsilcicheckbox"
                        value=""
                        id="onaychecked"
                        required
                      />
                      <span
                        className="t-icAciklamaYazi"
                        style={{ paddingLeft: 10, position: "relative" }}
                      >
                        Yukarıda belirtmiş olduğum soru ile ilgili gerekli işlemlerin
                        yapılması amacıyla kişisel verilerimin ilgili personel ile
                        paylaşılmasına rıza gösteriyorum.<strong>ONAYLIYORUM</strong>
                        <div className="t-tooltip">
                          <i className="t-icon-arrow-left pr-1" />
                          Devam Etmek İçin Onaylamalısınız
                        </div>
                      </span>
                    </div>
                    {/* Button */}
                    <div className="col-12 d-flex justify-content-center pb-3">
                      <button className="t-icButonMavi" onClick={this.onSubmit}>
                        <span>Mesajımı Gönder</span>
                        <i className="t-icon-arrow-right2" />
                      </button>
                    </div>
                  </div>
                  {/* içerikler BİTTİ */}
                </div>
                <div className="col-auto renk" />
              </div>
              {/* KUTU 1 BİTTİ */}
            </div>
          </div>

          <div className="row" style={{ height: 30 }} />
        </div>

      );
    }
  }
}
const mapStateToProps = (state) => {
  return {
    workflow: selectWorkflow(state)
  };
};

const mapDispatchToProps = (dispatch) => ({
  askToAgents: (konu, aciklama) =>
    dispatch(askToAgents(konu, aciklama))
});

export default connect(mapStateToProps, mapDispatchToProps)(AskToAgent);
